import { apiRaw, api } from './api'

export interface WaitlistResponse {
  success: boolean
  message: string
  position?: number
  total?: number
  referral_code?: string
  referrer_bonus?: boolean
  referral_count?: number
}

export interface WaitlistPositionData {
  position: number
  total: number
  referral_code: string
  referrals: number
  spots_jumped: number
  next_milestone: {
    referrals: number
    reward: string
  } | null
}

interface WaitlistLeaderboardResponse {
  leaders: Array<{
    rank: number
    name: string
    referrals: number
    is_you: boolean
  }>
  your_rank: number | null
}

export async function joinWaitlist(email: string, referralCode?: string): Promise<WaitlistResponse> {
  const response = await apiRaw('/api/waitlist', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email,
      referral_code: referralCode || undefined,
    }),
  })

  return response.json()
}

export async function getWaitlistPosition(email: string): Promise<WaitlistPositionData> {
  const response = await apiRaw(
    `/api/waitlist/position?email=${encodeURIComponent(email)}`
  )
  if (!response.ok) {
    throw new Error(`Failed to fetch waitlist position (${response.status})`)
  }
  return response.json()
}

export async function getWaitlistLeaderboard(email?: string): Promise<WaitlistLeaderboardResponse> {
  const query = email ? `?email=${encodeURIComponent(email)}` : ''
  const response = await apiRaw(`/api/waitlist/leaderboard${query}`)
  if (!response.ok) {
    throw new Error(`Failed to fetch leaderboard (${response.status})`)
  }
  return response.json()
}

export async function getReferralStats() {
  return api.get('/api/referral/stats')
}

export async function claimReferralMilestone(milestoneType: string) {
  return api.post('/api/referral/claim-milestone', { milestone_type: milestoneType })
}

